import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CircularProgress,
  styled,
  Typography,
} from "@mui/material";
import {useViewport} from "../../helpers";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {useSnackbar} from "notistack";
import {useSelector} from "react-redux";
import {ArrowBack, ExpandMore} from "@mui/icons-material";
import {myClassesServices} from "../../services";
import ClassStats from "../myExparience/classes/ClassStats";

const PREFIX = "ClassesManagementStats";

const classes = {
  classesListMainContainer: `${PREFIX}-classesListMainContainer`,
};

const Root = styled("div")(({theme}) => ({
  [`& .${classes.classesListMainContainer}`]: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    maxHeight: "725px",
    padding: "0.5rem",
    marginTop: "1rem",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#d3af5f",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      padding: "0",
    },
  },
}));

const ClassesManagementStats = ({setIsStats, accountId, group}) => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const {width} = useViewport();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const isAdmin = useSelector((state) => state.user.currentUser.account.role);

  useEffect(() => {
    // Fetch data from API
    const myService = isAdmin
      ? myClassesServices.getExpariencesByGroup(group.id)
      : myClassesServices.getGroupsWithStats();
    myService.then((data) => {
      setData(data);
      setLoading(false);
    })
      .catch((error) => {
        enqueueSnackbar(t("toasts.fetchGroupsError"), {variant: "error"});
      });
  }, [enqueueSnackbar, t, isAdmin, accountId]);

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "2rem",
        }}
      >
        <CircularProgress size={50}/>
        <Typography>{t("loaders.fetching")}</Typography>
      </Box>
    );
  else
    return (
      <Root sx={{width: "100%", maxWidth: "850px"}}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative"
          }}
        >
          <Button variant="contained" onClick={() => setIsStats(false)}
                  size={width >= 768 ? "medium" : "small"}
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: width >= 768 ? "90px" : "9%",
                  }}
          >
            <ArrowBack/>
          </Button>
          <Typography variant="h4">
            {t("classManagement.classStatsTitle")}
          </Typography>
        </Box>
        <Box>
          <Card elevation={4} className={classes.classesListMainContainer}>
            {data.length === 0 &&
              <Typography variant="body1" sx={{padding: '1rem', textAlign: "center"}}>
                {t("classManagement.noData")}
              </Typography>
            }
            {data?.map((item, index) => {
              return (
                <Accordion
                  key={`exparience-group-${item.id}-${index + 1}`}
                  elevation={8}
                  sx={{width: "100%", marginBottom: "1rem"}}
                >
                  <AccordionSummary expandIcon={<ExpandMore/>}>
                    <Box sx={{display: "flex", alignItems: "center"}}>
                      {item.logoUrl ? (
                        <img
                          alt="avatar"
                          src={item.logoUrl}
                          loading="lazy"
                          style={{borderRadius: "5px", maxWidth: "80px", maxHeight: "80px"}}
                        />
                      ) : (
                        <Box sx={{height: "80px"}}/>
                      )}
                      <Typography variant="body1" sx={{marginLeft: "1rem"}}>
                        {item.displayName || item.name}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      borderTop: "1px solid rgba(255, 255, 255, 0.18)",
                      padding: 0,
                    }}
                  >
                    <ClassStats exparience={item} groupId={group?.id}/>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Card>
        </Box>
      </Root>
    );
};

export default ClassesManagementStats;
